<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter :headers="payHeaders" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
          <v-data-table
            :headers="payHeaders"
            :items="payOrders"
            :options.sync="pagination"
            :server-items-length="totalPayOrders"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{item.ID}}</td>
                <td>{{ item.CustomerName }}</td>
                <td class="text-end font-weight-bold">{{item.TotalAmountVND | currency}}</td>
                <td class="text-end">{{ item.Deposit | currency}}</td>
                <td class="text-end">{{ item.PayLeft | currency}}</td>
                <td class="text-end">{{ item.Wallet | currency}}</td>
                <td class="text-end font-weight-bold">{{ item.Remain | currency}}</td>
                <td class="text-end">{{ item.OrderNumber | currency}}</td>
                <td class="text-end">{{ item.OrderNumberTran | currency}}</td>
                <td class="text-center pay-button">
                  <v-btn text icon color="red lighten-2" @click="openPayDetail(item.ID)">
                    <v-icon>fa-check-double</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-dialog v-model="dialogPayDetail" max-width="700px">
            <v-card>
              <v-card-title>
                <span class="title">Thanh toán đơn hàng</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md pa-0>
                  <v-layout row wrap>
                    <v-flex lg12>
                      <div>Mã khách hàng: {{payOrderDetail.CustomerID}}</div>
                    </v-flex>
                    <v-flex lg12>
                      <div>Tài khoản: {{payOrderDetail.CustomerName}}</div>
                    </v-flex>
                    <v-flex lg12>
                       <v-text-field v-model="phoneNumber" label="Điện thoại" class="input-group--focused"></v-text-field>
                    </v-flex>
                    <v-flex lg12>
                       <v-text-field v-model="payOrderDetail.Address" label="Địa chỉ" class="input-group--focused"></v-text-field>
                    </v-flex>
                     <v-flex lg12>
                       <v-text-field v-model="shippingMethod" label="Hình thức ship" class="input-group--focused"></v-text-field>
                    </v-flex>
                    <v-flex lg12 class="font-weight-bold">
                      <div>Số đơn thanh toán: {{selected.length | currency}}</div>
                    </v-flex>
                    <v-flex lg12>
                      <v-data-table
                        :headers="orderHeader"
                        :items="payOrderDetail.Orders"
                        :mobile-breakpoint="100"
                        :items-per-page="10000"
                        :hide-default-footer="true"
                        item-key="ID"
                        show-select
                        v-model="selected"
                      >
                        <template v-slot:item="{ item, isSelected, select }">
                          <tr :active="isSelected" @click="select(!isSelected)">
                            <td>
                              <v-checkbox primary hide-details :input-value="isSelected"></v-checkbox>
                            </td>
                            <td>{{ item.TransactionCode }}</td>
                            <td>{{ item.TransactionStatus | display_value(package_status) }}</td>
                            <td class="text-end">{{ (item.WeightByVolume > item.Weight && currentCustomer.IsWeightByVolume ? item.WeightByVolume : item.Weight) | currency('',2) }}</td>
                            <td>
                              <a target="blank" :href="(item.OrderType == 1 ? '/don-hang/' : '/ky-gui/') + item.ID">{{(item.OrderType == 1 ? 'MD' : 'KG') +item.ID}}</a>
                            </td>
                            <td class="text-end font-weight-bold" v-if="!item.IsChild">{{ item.TotalAmountVND | currency}}</td>
                            <td v-else></td>
                            <td class="text-end" v-if="!item.IsChild">{{ item.Deposit | currency}}</td>
                            <td v-else></td>
                            <td class="text-end" v-if="!item.IsChild">{{ item.PayLeft | currency}}</td>
                            <td v-else></td>
                          </tr>
                        </template>
                        <template v-slot:body.append>
                          <tr>
                            <td colspan="5" class="font-weight-bold">Tổng</td>
                            <td class="text-end font-weight-bold">{{totalAmount | currency}}</td>
                            <td class="text-end font-weight-bold">{{totalDeposit | currency}}</td>
                            <td class="text-end font-weight-bold">{{totalPayLeft | currency}}</td>
                          </tr>
                          <tr>
                            <td colspan="7" class="font-weight-bold">Phí ship</td>
                            <td class="text-end font-weight-bold">
                              <h-currency-input
                                class="fee-cn-footer"
                                v-model="shipFee"
                                :decimal="0"
                              ></h-currency-input>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="7" class="font-weight-bold"><v-text-field label="Phí khác" v-model="feeOtherName"></v-text-field></td>
                            <td class="text-end font-weight-bold">
                              <h-currency-input
                                class="fee-cn-footer"
                                v-model="feeOther"
                                :decimal="0"
                              ></h-currency-input>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="7" class="font-weight-bold">Số dư ví</td>
                            <td
                              class="text-end font-weight-bold"
                            >{{payOrderDetail.Wallet | currency}}</td>
                          </tr>
                          <tr>
                            <td colspan="7" class="font-weight-bold">Cần trả thêm</td>
                            <td class="text-end font-weight-bold">{{totalRemain | currency}}</td>
                          </tr>
                          <tr>
                            <td colspan="7" class="font-weight-bold"><v-select label="Hình thức thanh toán" v-model="method" :items="rechargeMethods" item-text="name" item-value="value" :readonly="csRole"></v-select></td>
                            <td class="text-end font-weight-bold">
                              <h-currency-input
                                class="fee-cn-footer"
                                v-model="inputCash"
                                :decimal="0"
                              ></h-currency-input>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-3 white--text" @click="dialogPayDetail = false">Đóng</v-btn>
                <!-- <v-btn
                  color="black darken-3 white--text"
                  @click="saveDeliverOrder(0)"
                  :disabled="selected.length == 0"
                >Huỷ xuất kho</v-btn>
                <v-btn
                  color="red darken-3 white--text"
                  @click="saveDeliverOrder(1)"
                  :disabled="selected.length == 0"
                >Xuất kho</v-btn> -->
                <v-btn
                  color="green darken-3 white--text"
                  @click="savePayOrder"
                  :disabled="selected.length == 0"
                >Thanh toán</v-btn>
                <v-btn absolute top right class="mt-5" @click="printPayOrder">
                  <v-icon color="red darken-2" class="mr-2">fa-print</v-icon>In đơn
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="loading" fullscreen>
            <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
              <v-layout justify-center align-center>
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </v-layout>
            </v-container>
          </v-dialog>
        </v-card>
      </v-flex>
    </v-layout>
    <div class="pt-5">
      <h3>Lịch sử thanh toán</h3>
    </div>
    <payment-history class="px-0"></payment-history>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";
import { currency } from "@/commons/currency";
import { sendErrorNotice, getCurrentTime } from "@/commons/utils";
import { print_export_payment_order } from '@/commons/hpod';
import PaymentHistoryList from "@/views/PaymentHistory/PaymentHistoryList.vue";
export default {
  components: {
    "hpo-filter": Filtering,
    "payment-history": PaymentHistoryList
  },
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      timeout: 2000,
      payMode: false,
      search: "",
      feeOtherName: "",
      feeOther: 0,
      inputCash: 0,
      shipFee: 0,
      method: configs.RECHARGE_TYPE.COD,
      package_status: configs.PACKAGE_STATUS,
      shippingMethod: "",
      rechargeMethods: _.filter(configs.RECHARGE_METHODS, function(o) { return o.value >= 90; }),
      payHeaders: [
        {
          text: "Mã khách hàng",
          value: "ID",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Khách hàng",
          value: "CustomerName",
          quickSearch: true,
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Tổng tiền",
          value: "TotalAmountVND",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Đã trả",
          value: "Deposit",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Tiền thiếu",
          value: "PayLeft",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Tài khoản",
          value: "Wallet",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Cần trả thêm",
          value: "Remain",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Số đơn hàng",
          value: "OrderNumber",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Đơn đang vận chuyển",
          value: "OrderNumberTran",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          align: "center",
          filterable: false,
          sortable: false
        }
      ],
      orderHeader: [
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          right: false
        },
        {
          text: "Trạng thái",
          value: "TransactionStatus",
          right: false
        },
        {
          text: "Cân nặng",
          value: "Weight",
          align: "end"
        },
        {
          text: "Đơn hàng",
          value: "ID",
          right: false
        },
        {
          text: "Tổng tiền",
          value: "TotalAmountVND",
          align: "end"
        },
        {
          text: "Đã trả",
          value: "Deposit",
          align: "end"
        },
        {
          text: "Còn thiếu",
          value: "PayLeft",
          align: "end"
        }
      ],
      selected: [],
      pagination: _.cloneDeep(configs.PAGINATION),
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "payorder_list",      
      filterConditions: [],
      quickFilterConditions: [],
      dialogPayDetail: false,
      phoneNumber: '',
      orderStatus: configs.ORDER_STATUS_ENUM
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
        this.filter_data();
      },
      deep: true
    },
    payOrderDetail() {
      this.phoneNumber = this.payOrderDetail ? this.payOrderDetail.PhoneNumber : '';
    },
    dialogPayDetail() {
      this.selected = [];
       this.feeOther = 0;
       this.inputCash = 0;
       this.shipFee = 0;
       this.method = configs.RECHARGE_TYPE.COD;
       this.shippingMethod = "";
    }
  },
  computed: {
    ...mapState("payOrder", {
      payOrders: "all",
      totalPayOrders: "total",
      payOrderDetail: "selectedItem",
      loading: "loading",
    }),
    ...mapState("customer", {
      currentCustomer: "selected",
    }),
    pages() {
      if (this.options.rowsPerPage == null || this.options.totalItems == null)
        return 0;

      return Math.ceil(this.options.totalItems / this.options.rowsPerPage);
    },
    selectedUniq() {
      return _.uniq(_.map(this.selected, (item) => {return {
        'ID': item.ID,
        'OrderType': item.OrderType,
        'TotalAmountVND': item.TotalAmountVND,
        'Deposit': item.Deposit,
        'PayLeft': item.PayLeft
      }}));
    },
    totalAmount() {
      return _.sumBy(this.selectedUniq, "TotalAmountVND");
    },
    totalDeposit() {
      return _.sumBy(this.selectedUniq, "Deposit");
    },
    totalPayLeft() {
      return _.sumBy(this.selectedUniq, "PayLeft");
    },
    totalRemain() {
      return this.payOrderDetail.Wallet >= this.totalPayLeft + this.shipFee + this.feeOther
        ? 0
        : this.totalPayLeft + this.shipFee + this.feeOther - this.payOrderDetail.Wallet;
    },
    adminRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
    },
    paymentRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
    },
    csRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService;
    },
  },
  methods: {
    filter_data: function() {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("payOrder/getPayOrderList", param);
    },
    toggleAll() {
      if (this.selected.length === this.payOrderDetail.Orders.length)
        this.selected = [];
      else this.selected = this.payOrderDetail.Orders.slice();
    },
    openPayDetail(customerId) {
      this.$store.dispatch("payOrder/getPayOrderDetail", customerId);
      this.$store.dispatch("customer/getCustomerDetail", customerId);
      this.dialogPayDetail = true;
      this.selected = [];
    },
    saveDeliverOrder(deliverable = 1) {
      let order_ids = _.map(_.filter(this.selected, {'OrderType': 1}), "ID");
      if(order_ids.length > 0) {
        this.$store.dispatch("main_order/updateMultiple", {
          OrderIDs: order_ids,
          Deliverable: deliverable
        });
      }
      let deposit_ids = _.map(_.filter(this.selected, {'OrderType': 2}), "ID");
      if(deposit_ids.length > 0) {
        this.$store.dispatch("deposit/updateMultiple", {
          OrderIDs: deposit_ids,
          Deliverable: deliverable
        });
      }
      this.$store.dispatch("orderTransaction/updateMultiple", {
        OrderIDs: order_ids,
        DepositIDs: deposit_ids,
        ShippingInfo: `${this.payOrderDetail.CustomerName} - ${this.phoneNumber} - ${this.payOrderDetail.Address}`,
        ShippingMethod: this.shippingMethod
      });
      this.dialogPayDetail = false;
      setTimeout(this.filter_data, 300);
    },
    savePayOrder() {
      if (this.selected.length == 0) {
        sendErrorNotice("Hãy chọn hóa đơn cần thanh toán");
        return;
      }
      // if (this.totalRemain > this.inputCash) {
      //   sendErrorNotice("Hãy nhập thêm tiền mặt");
      //   return;
      // }
      this.$store.dispatch("payOrder/updatePayOrder", {
        order_ids: _.map(_.filter(this.selectedUniq, {'OrderType': 1}), "ID"),
        deposit_ids: _.map(_.filter(this.selectedUniq, {'OrderType': 2}), "ID"),
        totalPayLeft: this.totalPayLeft,
        cash: this.inputCash,
        method: this.method,
        shipFee: this.shipFee,
        feeOther: this.feeOther,
        feeOtherName: this.feeOtherName,
        customer_id: this.payOrderDetail.CustomerID,
        shippingMethod: this.shippingMethod,
        shippingPhone: this.phoneNumber,
        shippingAddress: this.payOrderDetail.Address
      }).then((ret) => {
        if(ret.status == 200) {
          this.$store.dispatch("orderTransaction/updateMultiple", {
            OrderIDs: _.map(_.filter(this.selectedUniq, {'OrderType': 1}), "ID"),
            DepositIDs: _.map(_.filter(this.selectedUniq, {'OrderType': 2}), "ID"),
            ShippingInfo: `${this.payOrderDetail.CustomerName} - ${this.phoneNumber} - ${this.payOrderDetail.Address}`,
            ShippingMethod: this.shippingMethod
          });
        }
      });
      
      this.dialogPayDetail = false;
      setTimeout(this.filter_data, 300);
    },
    printPayOrder() {
      let list_packages = _.filter(this.payOrderDetail.Orders, (p) => {
        return _.find(this.selectedUniq, (m) => {
          return m.ID == p.ID && m.OrderType == p.OrderType;
        }) != null;
      });
      const frame_printing = print_export_payment_order({
        CustomerName: this.payOrderDetail.CustomerName,
        PhoneNumber: this.phoneNumber,
        Address: this.payOrderDetail.Address,
        NumberOfOrder: this.selectedUniq.length,
        FeeOtherName: this.feeOtherName,
        FeeOther: this.feeOther,
        TotalAmount: this.totalAmount,
        TotalDeposit: this.totalDeposit,
        TotalPayLeft: this.totalPayLeft,
        Wallet: this.payOrderDetail.Wallet,
        ShipFee: this.shipFee,
        TotalRemain: this.totalRemain,
        InputCash: this.inputCash,
        IsWeightByVolume: this.currentCustomer.IsWeightByVolume
      }, list_packages, true);
      var doc = document.getElementById('print_frame').contentWindow.document;
      doc.open();
      doc.write(frame_printing);
      doc.close();
      setTimeout(function(){ window.frames["print_frame"].window.print(); }, 1000);
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy
      let sortDesc = this.pagination.sortDesc
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    }
  },
  mounted() {
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
  }
};
</script>

<style>
.pay-button {
  width: 135px;
}

.fee-cn-footer .v-text-field .v-label--active {
  right: 0px !important;
  left: auto !important;
}

.fee-cn-footer .v-text-field__slot input {
  text-align: right !important;
  font-size: 0.9em !important;
}
</style>
